import styled from 'styled-components';
import { rem } from 'polished';
import { InteriorSelectStyled } from '../../InteriorSelectStyled';

export const InteriorSelectStyledOVGB = styled(InteriorSelectStyled)`
    .react-multiple-carousel__arrow {
        border-width: ${rem(2)};

        &:hover,
        &:focus-visible {
            background: ${({ theme }) => theme.colors.white};
            border-color: ${({ theme }) => theme.colors.primary};

            &::before {
                color: ${({ theme }) => theme.colors.primary};
            }
        }
    }
    .interiorTitle {
        font-size: ${rem(16)};

        .selectedBorder {
            border: 1px solid ${({ theme }) => theme.colors.primary};
        }
    }

    .interiorPrice {
        font-size: ${({ theme }) => theme.fontSizes.h5};
    }

    .isSelected {
        background: ${({ theme }) => theme.colors.red7};
    }
`;
